import { useIsMobile } from '~/context/common/DeviceContext';
import type { RecommendedVehicle } from '~/contracts/common';
import DeliveryCard from './DeliveryCard';
import DeliveryHeader from './DeliveryHeader';
import { CardWrapper } from './PickupAndDelivery.styles';

type OwnProps = {
  vehicles: RecommendedVehicle[];
};

const SimilarVehicles = ({ vehicles }: OwnProps) => {
  const isMobile = useIsMobile();
  const tileCount = isMobile ? 1 : 2;
  const vehiclesOnPage = vehicles.slice(0, tileCount);
  const modalVehicles = vehicles.slice(tileCount, vehicles.length);

  return (
    <div className="p-24 m:p-0">
      <DeliveryHeader vehicles={modalVehicles} />
      <CardWrapper
        className={
          vehiclesOnPage.length === 1 ? 'justify-center' : 'justify-between'
        }
      >
        {vehiclesOnPage.map(vehicle => (
          <DeliveryCard vehicle={vehicle} key={vehicle.vehicleId} />
        ))}
      </CardWrapper>
    </div>
  );
};

export default SimilarVehicles;
